import React from 'react';
import { connect } from 'dva';
import { Layout, Form, Breadcrumb, Input, Modal, AutoComplete } from 'antd';
import Icon from 'components/Icon';
import SwitchTab from 'components/SwitchTab';
import BaseComponent from 'components/BaseComponent';
import DataTable from 'components/DataTable';
import UploadModal from 'components/Upload';
import '../index.less';
import '@/assets/styles/public.less';
import { buildMaterialMenuTree } from '@/routes/Material/Folder/service';
import { contentRsg } from '@/utils/common/constants';
import { getUserFolderId, getUserOrgId, createTreeNodes, getUpdateUrl, getDownloadUrl, materialTitleObjMap } from '@/routes/Material/Util/components/materialUtil';
import { MaterialGraphComponent, AddEditFolderComponent, MaterialListComponent, MaterialTreeComponent, AddWebComponent, PreviewComponent, RenameComponent, AddEditRss } from '@/routes/Material/Util/index';
import { columnsPicture, columnsVideo, columnsMusic, columnsOffice, columnsLive, columnsDynamicText } from './columns';
import moment from 'moment';
import config from '@/config';
import $$ from 'cmn-utils';
import {
  multiTime,
  getWinSize,
  getMenuWidth,
} from '@/utils/common';
const notice = config.notice;
const { Content, Sider, Header, Footer } = Layout;
const Pagination = DataTable.Pagination
const confirm = Modal.confirm;
@connect(({ material, loading }) => ({
  material,
  loading: loading.models.material,
}))
@Form.create()
export class MaterialComponent extends BaseComponent {
  
  constructor(props) {
    super(props);
    this.userFolderId = getUserFolderId();
    this.userOrgId = getUserOrgId();
    //currentType === '0' 视频, currentType === '1' 图片, currentType === '2' 音乐, currentType === '7' 网页, currentType === '15' Word, currentType === '16' Excel, currentType === '17' PPT, currentType === '18' RSS, currentType === '35' PDF
    let currentType = '1';
    let { type } = this.props;
    if (type && type.length > 0) {
      currentType = type[0];
    }
    this.state = {
      typeData: { currentType, isShare: '0', otherShare: '0' },      // 当前显示的素材type / 是否分享状态 0:不分享 1:分享 / 查询别人共享的素材
      folderId: this.userFolderId,                  // 当前登录的用户所在的默认文件夹id
      tabsType: '0',                                // 选中内容 0:我的素材 1:共享素材
      graphListType: '0',                           // 显示状态 0:图形模式 1:列表模式
      btnDisabled: [true, true, true, true, true, true],  // 下载、复制、剪切、粘贴、删除、分享/取消分享
      routes: [{ id: this.userFolderId, breadcrumbName: window.language['material.allFiles'] + "_" + this.userFolderId }],   // 面包屑
      checkRows: [],                                // 选中rows数组
      checkKeys: [],                                // 选中keys数组
      checkObj: {},                                 // 单个素材块选中的值
      showKeys:[],                                  // 列表模式工具栏显示更多的列
      collapsed: false,                             // 左侧sider是否展开/伸缩
      folderTitle: {},                              // 标题:新建、编辑文件夹
      folderNodes: {},                              // 左侧树数据
      floderNodesChange: false,                     // 减少左侧树的渲染
      liveTitle: {},                                // 流媒体、web: 0:新建 1:修改
      dynamicTextTitle: {},                         // RSS 0:新建 1:编辑
      previewRows: [],                              // 会预览的所有素材
      copyKeys: {},                                 // 拷贝内容
      copyCutStatus: '',                            // 拷贝或剪切状态 0: 拷贝 1:剪切
      uploadVisible: false,                         // 上传窗口显隐
      addFolderVisible: false,                      // 新建文件夹窗口显隐
      addLiveVisible: false,                        // 新建流媒体、web窗口显隐
      previewVisible: false,                        // 预览窗口显隐
      renameVisible: false,                         // 重命名窗口显隐
      rssVisible: false,                            // RSS窗口显隐
      modelVisible: false,                          // 素材模态窗显隐状态记录
      materialSize: {},                             // 图片展示区域大小
    }
  }
  clearInterval = () => {
    if (this.refreshInterval) {
      window.clearInterval(this.refreshInterval);
    }
  }

  setInterval = (pageData) => {
    this.clearInterval();
    
    this.refreshInterval = setInterval(() => {
      let flag = false;

      for (var index = 0; index < pageData.list.length; index++) {
        if(pageData.list[index].status === '0') {
          flag = true;
          break;
        }
      }

      if (flag) {
        pageData.jumpPage(1, pageData.pageSize);
        this.initSearch({}, 1, pageData.pageSize);
        this.onMaterialClear();
      }
    }, 1000);
  }

  onWindowResize = () => {
    let content = document.querySelector(".material-content-center");
    
    content = content || {offsetWidth: '100%', offsetHeight: '100%'};

    this.setState({
      materialSize: content
    })
  }

  componentDidMount() {
    this.qryMaterialList();
    this.getFoldersTree();
    const { material: { pageData } } = this.props;
    this.setInterval(pageData);
    this.onWindowResize();
    window.addEventListener('resize', this.onWindowResize)
  }

  componentWillUnmount() {
    const { material: { pageData } } = this.props;

    let { pageNum, pageSize } = pageData;

    this.clearInterval();

    pageSize = 10;

    //清空原数据
    pageData.list = [];

    pageNum = 1;
    
    pageData.jumpPage(pageNum, pageSize);
    window.removeEventListener('resize', this.onWindowResize)
  }
  
  componentWillReceiveProps(nextProps) {
      const { visible, type } = nextProps;
      let modelVisible = this.state.modelVisible;
      if(modelVisible !== visible) {
        if (visible === true) {
          this.onMaterialStateInit(type);
        }
        this.setState({
          modelVisible: visible
        });
      }
  }

  /** 查询素材 无参数 */
  qryMaterialList = () => {
    const { material: { pageData } } = this.props;
    pageData.pageNum = 1;
    pageData.pageSize = 10;
    this.initSearch({ searchType: 1 }, pageData.pageNum, pageData.pageSize);
    this.getFoldersTree();
    this.onMaterialClear();
  }

  /** 查询素材 有参数 */
  initSearch = (values, pageNum, pageSize) => {
    let payload = this.getPayload(values, pageNum, pageSize);
    let { modal } = this.props;
    if (modal === 'playlist') {
      payload.status = "1";
    }
    this.props.dispatch({
      type: 'material/qryMaterialList',
      payload
    });
  }

  /** 根据条件模糊查询 */
  onSearch = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { material: { pageData } } = this.props;
        let btnDisabled = this.state.btnDisabled;
        this.setState({
          routes: [{ id: this.userFolderId, breadcrumbName: window.language['material.allFiles'] + "_" + this.userFolderId }],
          folderId: this.userFolderId,
          checkRows: [],
          checkKeys: [],
          showKeys: [],
          checkObj: {},
          btnDisabled: [true, true, true, btnDisabled[3], true, true],
        }, () => {
          this.initSearch(values, pageData.pageNum, pageData.pageSize);
        });
      }
    });
  }
  

  /** 获取查询参数 */
  getPayload = (values, pageNum, pageSize) => {
    let { name = "", pid = "", folderId = "" } = values;
    let { currentType, isShare, otherShare } = this.state.typeData;
    if (pid === "") {
      pid = this.state.folderId;
    }
    if (folderId === "") {
      folderId = this.state.folderId;
    }
    let payload = {
      type: currentType,
      currentPage: pageNum,
      rowSize: pageSize,
      name,
      is_share: isShare,    // 是否分享 0:否 1:是
      otherShare,
    }
    if (name) {
      payload['pid'] = '';
      this.setState({
        folderId: this.userFolderId,
      });
    } else {
      payload['pid'] = pid;
      payload['folderIds'] = folderId;
    }
    return payload;
  }

  /** 清空素材所有选中状态 */
  onMaterialClear = () => {
    let btnDisabled = this.state.btnDisabled;
    this.setState({
      checkRows: [],
      checkKeys: [],
      showKeys: [],
      checkObj: {},
      btnDisabled: [true, true, true, btnDisabled[3], true, true],
    });
  }

   /** 清空拷贝的内容 */
   onCopyDataClear = () => {
    this.setState({
      checkRows: [],
      checkKeys: [],
      showKeys: [],
      checkObj: {},
      copyKeys: {},
      copyCutStatus: '',
      btnDisabled: [true, true, true, true, true, true],
    });
  }

  /**
   *  按钮的过滤条件 
   *  下载:   支持多个   不支持文件夹   支持图片
   *  复制:   支持多个   不支持文件夹   支持图片
   *  剪切:   支持多个   支持文件夹     支持图片
   *  粘贴:   在复制、剪切数据后才可以
   *  删除:   支持多个   支持文件夹     支持图片
   *  分享:   支持多个   不支持文件夹   支持图片
   */
  getMenuFilter = () => {
    let { checkRows, btnDisabled: btn } = this.state;
    let paste =  btn[3];
    if (checkRows.length === 0) {   // 没有选中数据
      btn = [true, true, true, paste, true, true];
    }
    else if (checkRows.length > 1) {  // 选中多个数据
      let flag = false;
      for (let ele of checkRows) {
        if (ele.scope) {  // 存在文件夹
          flag = true;
          break;
        }
      }
      if (flag) { // 选中文件夹
        btn = [true, true, false, paste, false, true];
      } else {
        btn = [false, false, false, paste, false, false];
      }
    }
    else {  // 选中一个数据
      let ele = checkRows[0];
      if (ele.scope) { // 选中文件夹
        btn = [true, true, false, paste, false, true];
      } else {
        btn = [false, false, false, paste, false, false];
      }
    }
    this.setState({
      btnDisabled: btn,
    });
  }

  /** 初始化状态 */
  onMaterialStateInit = (type) => {
    let currentType = '1';
    if (type && type.length > 0) {
      currentType = type[0];
    }
    let typeData = { currentType, isShare: '0', otherShare: '0' };
    this.setState({
      typeData,      // 当前显示的素材type / 是否分享状态 0:不分享 1:分享 / 查询别人共享的素材
      folderId: this.userFolderId,                  // 当前登录的用户所在的默认文件夹id
      tabsType: '0',                                // 选中内容 0:我的素材 1:共享素材
      graphListType: '0',                           // 显示状态 0:图形模式 1:列表模式
      routes: [{ id: this.userFolderId, breadcrumbName: window.language['material.allFiles']  + "_" + this.userFolderId }],   // 面包屑
      collapsed: false,
      checkRows: [],
      checkKeys: [],
    }, () => {
      this.props.getCheckRowsKeys && this.props.getCheckRowsKeys([], [], typeData);
      this.qryMaterialList();
    });
  }
  
  /**
   * 点击素材选中状态
   * rows: object 选中的rows
   * keys: object 选中的keys
   */
  onMaterialChecked = (checkRows, checkKeys) => {
    let { getCheckRowsKeys } = this.props;
    this.setState({
      checkRows,
      checkKeys
    }, () => {
      this.getMenuFilter();
      getCheckRowsKeys && getCheckRowsKeys(checkRows, checkKeys, this.state.typeData);
    });
  }

  /** 点击tab切换 0:我的素材 1:共享素材 */
  onChangeTabs = (e, type) => {
    let { currentType, isShare, otherShare } = this.state.typeData;
    if (type === '1') {
      isShare = '1';
      otherShare = '1';
    } else {
      isShare = '0';
      otherShare = '0';
    }
    this.setState({
      tabsType: type,
      typeData: { currentType, isShare, otherShare }
    }, () => {
      this.qryMaterialList();
    });
  }

  /** 双击数据 素材类型是文件夹则打开 */
  onDoubleClickData = (e, row) => {
    const { dispatch, form } = this.props;
    let { typeData: { currentType } } = this.state;
    let id = row.id.split("_")[0];
    if (!row.scope) {
      if (currentType !== '7' && currentType !== '18') {
        this.onShowPreviewHandler(e, row);
      }
      return;
    }
    if (id === this.userFolderId) {
      let routesArr = [{ id: this.userFolderId, breadcrumbName: window.language['material.allFiles'] + "_" + this.userFolderId }];
      this.onRoutesChange(routesArr, { pid: id, folderId: id });
    } else {
      dispatch({
        type: 'folder/qryFolderParentList',
        condition: { id },
        success: (folderArr) => {
          if (!folderArr) {
            return;
          }
          // 打开文件夹前，先将搜索框内容清空
          form.resetFields();
          let routesArr = [{ id: this.userFolderId, breadcrumbName: `${window.language['material.goBack']}` + "_" + this.userFolderId + ` / ${window.language['material.all']}${materialTitleObjMap.get(currentType).title}` + "_" + this.userFolderId }];
          for (let i = folderArr.length - 1; i >= 0; i--) {
            let f = folderArr[i];
            routesArr.push({ 'id': f.id, 'breadcrumbName': f.name + "_" + f.id })
          }
          this.onRoutesChange(routesArr, { pid: id, folderId: id });
        }
      });
    }
  }

  /** 只选中 */
  onCheckedMaterialData = (ele) => {
    let rows = this.state.checkRows;
    let keys = this.state.checkKeys;
    let rowsFindIndex = rows.findIndex(val => val.id === ele.id);
    if (rowsFindIndex === -1) {
      rows = [...rows, ele];
      keys = [...keys, ele.id];
    }
    this.onMaterialChecked(rows, keys);
  }
  /** 
   * 面包屑显示内容更改
   * 0: 当前点击目录 1: 上级目录 2: 顶级目录
   */
  onSwitchBreadCrumb = (e, param, type) => {
    const { material: { pageData } } = this.props;
    let routesArr = this.state.routes;
    let folderId = param.id;
    let length = routesArr.length
    if (e) {
      e.preventDefault;
      e.stopPropagation;
    }
    pageData.pageNum = 1;
    if (length <= 2) { // 点击【返回上一级】或【全部文件】都显示全部文件
      routesArr = [{ id: folderId, breadcrumbName: window.language['material.allFiles'] }];
    } else {
      if (type === '1') { // 返回上一级
        let route = routesArr[length - 2];
        folderId = route.id;
        routesArr = routesArr.splice(0, length - 1);
      } else if (type === '0' || type === '2') { // 全部文件、任意某一文件夹
        let indexNum = routesArr.findIndex(val => val.id === folderId)
        routesArr.splice(indexNum + 1, length);
      }
    }
    this.onRoutesChange(routesArr, { pid: param.id, folderId });
  }

  /** 面包屑更改同时重新查询数据 */
  onRoutesChange = (routesArr, param) => {
    const { material: { pageData } } = this.props;
    const { pid, folderId } = param;
    const { btnDisabled } = this.state; 
    this.setState({
      routes: routesArr,
      folderId: folderId,
      checkRows: [],
      checkKeys: [],
      btnDisabled: [true, true, true, btnDisabled[3], true, true],
    });
    let values = {
      pid: pid,
      folderId: folderId
    };
    this.initSearch(values, pageData.pageNum, pageData.pageSize);
  }

  /** 图形模式和列表模式切换 */
  onSwitch = (type) => {
    this.setState({
      graphListType: type,
    });
  }

  /**
   * 显示/隐藏列表工具栏
   * key: 显示行的id
   * isMore: true: 显示 1:隐藏
   */
  onListToolAction = (e, key, isMore) => {
    if (e) {
      e.preventDefault;
      e.stopPropagation;
    }
    let showKeys = this.state.showKeys;
    if (isMore) {
      showKeys.push(key);
    } else {
      let index = showKeys.findIndex(val => val === key);
      if (index !== -1) {
        showKeys.splice(index, 1);
      }
    }
    this.setState({
      showKeys
    });
  }

  /** 左侧sider显示、隐藏 */
  onSiderToggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  /** 树点击后，右侧内容切换 */
  onChangeCurrentType = (typeData, folderId) => {
    const { material: { pageData } } = this.props;
    let { pageNum, pageSize } = pageData;
    let newCurrentType = typeData.currentType;
    let { typeData: { currentType: oldCurrentType } } = this.state;
    if (newCurrentType !== oldCurrentType) {
      pageSize = 10;
      this.onCopyDataClear();

      //清空原数据
      pageData.list = [];
    }
    pageNum = 1;
    pageData.jumpPage(pageNum, pageSize);
    let row = {
      id: folderId,
      scope: '1',
    }
    this.setState({
      typeData,
      folderId,
    }, () => {
      this.onDoubleClickData("", row);
    });
  }
  
  /** 获取所有素材文件夹的节点 */
  getFoldersTree = () => {
    //默认查询方法
    let postParams = {};
    buildMaterialMenuTree(postParams).then(({ code, msg, root: folderMap }) => {
      if (code === "200") {
        let { type } = this.props;
        let nodeList = new Array();
        //构造根节点
        let rootNode = {};
        rootNode["id"] = "0";
        rootNode["name"] = "";
        rootNode["pid"] = "_materialroot_";
        nodeList.push(rootNode);
        for (let currentType of type) {
          let fordersList = folderMap[currentType];
          // 每一种素材类型需添加一个节点
          let node2 = {};
          node2["id"] = "_materialtype_" + currentType;
          node2["name"] = "";
          node2["pid"] = "0";
          node2["type"] = currentType;
          nodeList.push(node2);
          fordersList.map(item => {
            let node = {};
            node["id"] = item.id;
            node["name"] = item.name;
            node["type"] = currentType;
            if (item.pid === this.userFolderId) {
              node["pid"] = "_materialtype_" + currentType;
            } else {
              node["pid"] = item.pid;
            }
            nodeList.push(node);
          });
        }
        let folderNodes = createTreeNodes(nodeList, type);
        this.setState({
          folderNodes,
          floderNodesChange: !this.state.floderNodesChange,
        });
      }
    });
  }

  /** 上传素材 显示窗口 */
  onShowUpload = (e) => {
    if (e) {
      e.preventDefault;
      e.stopPropagation;
    }

    if (this.state.uploadVisible === false) {
      this.setState({
        uploadVisible: true,
      });
    } else {
      //最大化上传控件模态框
      this.refs.uploadModalObj.changeNarrowVisible();
    }
  }

  /** 上传素材 隐藏窗口 */
  hideUploadHandler = (e) => {
    if (e) {
      e.preventDefault;
      e.stopPropagation;
    }
    this.setState({
      uploadVisible: false,
    });
  }

  /** 新建、编辑流媒体、web: 存入form */
  liveCompFormRef = (liveFormRef) => {
    this.liveFormRef = liveFormRef;
  }

  /** 新建、编辑流媒体、web: 隐藏窗口 */
  hideAddLiveHandler = () => {
    this.setState({
      addLiveVisible: false,
    });
  }

  /** 新建、编辑流媒体、web 
   * 显示窗口: type 0:新增 1:编辑 2:查看
   */
  onShowAddLive = (e, type, checkObj) => {
    if (e) {
      e.preventDefault;
      e.stopPropagation;
    }
    let { typeData: { currentType } } = this.state;
    let title = "";
    if (type === '0') {
      if (currentType === '7') {
        title = window.language['live.addWebUrl'];
      } else {
        title = window.language['live.addLive'];
      }
      this.setState({
        liveTitle: {
          type: '0',
          title
        },
        addLiveVisible: true,
      });
    } else if (type === '1') {
      if (currentType === '7') {
        title = window.language['live.updateWebUrl']
      } else {
        title = window.language['live.updateLive'];
      }
      this.setState({
        liveTitle: {
          type: '1',
          title,
        },
        checkObj,
        addLiveVisible: true,
      });
    } else {
      if (currentType === '7') {
        title = window.language['live.findWeb'];
      } else {
        title = window.language['live.findLive'];
      }
      this.setState({
        liveTitle: {
          type: '2',
          title,
        },
        checkObj,
        addLiveVisible: true,
      });
    }
  }

  /** 新建、编辑流媒体、web:保存 */
  addLiveHandler = () => {
    const { material: { pageData }, dispatch } = this.props;
    const { filters, pageNum, pageSize } = pageData;
    const form = this.liveFormRef.props.form;
    let { liveTitle: { type : liveStatuType }, typeData: { currentType }, folderId } = this.state;
    if (liveStatuType === '2') {
      this.hideAddLiveHandler();
      return;
    }
    form.validateFields((err, values) => {
      if (!err) {
        let httpReg = /^(http:\/\/)/;
        let httpsReg = /^(https:\/\/)/;
        let rtmpReg = /^(rtmp:\/\/)/;
        let mms = /^(mms:\/\/)/;
        let rtsp = /^(rtsp:\/\/)/;
        const { id, name, remark, url } = values;
        if (httpReg.test(url) || httpsReg.test(url) || rtmpReg.test(url) || mms.test(url) || rtsp.test(url)) {
          let type = 'material/addLive';
          if (currentType === '7') {
            type = 'material/addLiveWeb';
          }
          let successTip = window.language['conmmon.add.success'];
          let payload = this.getPayload(filters, pageNum, pageSize);
          let condition = Object.assign({}, payload);
          condition.name = name;
          condition.remark = remark;
          condition.url = url;
          condition.folderId = folderId;
          condition.isAuditAuth = "1";
          condition.webType = currentType;
          condition.is_share = "";
          if (liveStatuType === '1') {
            type = 'material/updateLive';
            if (currentType === '7') {
              type = 'material/updateWeb';
            }
            successTip = window.language['conmmon.update.success']
            condition.id = id;
          }
          dispatch({
            type,
            condition: condition,
            payload: payload,
            success: () => {
              notice.success(successTip);
              this.hideAddLiveHandler();
              this.onMaterialClear();
            }
          });
        } else {
          notice.error(window.language['live.urlIsWrong']);
        }
      }
    });
  }

  /**
   * 新建、编辑文件夹
   * 显示窗口: type 0:新建 1:编辑
   */
  onShowAddFolder = (e, type, checkObj) => {
    if (e) {
      e.preventDefault;
      e.stopPropagation;
    }
    if (type === '0') {
      this.setState({
        folderTitle: {
          type: '0',
          title: window.language['material.folder.newFolder'],
        },
        addFolderVisible: true,
      });
    } else {
      this.setState({
        folderTitle: {
          type: '1',
          title: window.language['material.folder.editFolder'],
        },
        checkObj,
        addFolderVisible: true,
      });
    }
  }

  /** 新建、编辑文件夹: 隐藏窗口 */
  hideAddEditFolderHandler = () => {
    this.setState({
      addFolderVisible: false,
    });
  }

  /** 新建、编辑文件夹: 存入form */
  saveAddEditFolderCompFormRef = (addEditFolderFormRef) => {
    this.addEditFolderFormRef = addEditFolderFormRef;
  }

  /** 新建、编辑文件夹: 保存文件夹 */
  addEditFolderHandler = () => {
    const { material: { pageData }, dispatch } = this.props;
    const { filters, pageNum, pageSize } = pageData;
    const form = this.addEditFolderFormRef.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        let { folderTitle: { type }, typeData: { currentType } } = this.state;
        let payload = this.getPayload(filters, pageNum, pageSize);
        let condition = Object.assign({}, payload);
        condition.name = values.name.trim();
        condition.remark = values.remark.trim();
        condition.scope = "0";
        condition.type = currentType;
        let url = "material/addFolder";
        let successTip = window.language['conmmon.add.success']
        if (type === '1') {
          url = "material/updateFolder";
          successTip = window.language['conmmon.update.success']
          condition.id = values.id.split("_")[0];
        }
        dispatch({
          type: url,
          condition: condition,
          payload: payload,
          success: () => {
            this.hideAddEditFolderHandler();
            notice.success(successTip);
            this.getFoldersTree();
            this.onMaterialClear();
          }
        });
      }
    });
  }

  /** 全选功能 */
  onCheckAll = () => {
    const { material: { pageData } } = this.props;
    let rows = [];
    let keys = [];
    let checkRows = this.state.checkRows;
    if (checkRows.length !== pageData.list.length) {
      rows = Object.assign([], pageData.list);
      if (!rows || rows.length <= 0) {
        return;
      }
      for (let item of rows) {
        keys.push(item.id);
      }
    }
    this.onMaterialChecked(rows, keys);
  }

  /** 复制、剪切功能 */
  onCopyCutFile = (copyCutStatus) => {
    let { checkRows, folderId, btnDisabled } = this.state;
    if(!checkRows || checkRows.length <= 0){
      notice.warning(window.language['material.selectPosterMaterial']);
      return;
    }
    let folderIds = [];
    let fileIds = [];
    for (let item of checkRows) {
      let id = item.id;
      if (item.scope) {
        id = id.split("_")[0];
        folderIds.push(id);
      } else {
        if (copyCutStatus === '1') {
          if (this.userOrgId !== item.org.id) {
            this.onCopyDataClear();
            notice.warning(window.language['material.nonsupportCutOrgTip']);
            return;
          }
        }
        fileIds.push(id);
      }
    }
    if (copyCutStatus === '0') {
      notice.success(window.language['material.copySuccess']);
    } else {
      notice.success(window.language['material.cutSuccess']);
    }
    btnDisabled[3] = false;
    this.setState({
      copyKeys: { folderIds, fileIds, copyFolderId: folderId },
      btnDisabled,
      copyCutStatus,
    });
  }

  /** 粘贴功能 */
  onPasteFile = (e) => {
    let copyCutStatus = this.state.copyCutStatus;
    if (!copyCutStatus) {
      return;
    }
    let { copyKeys: { folderIds, fileIds, copyFolderId } } = this.state;
    if ((!folderIds || folderIds.length <= 0) && (!fileIds || fileIds.length <= 0) && !copyFolderId) {
      notice.warning(window.language['material.noParseMaterial']);
      return;
    }
    if (copyCutStatus === '0') {
      this.onPasteCopyFile();
    } else if (copyCutStatus === '1') {
      this.onPasteCutFile();
    }
  }

  /** 粘贴复制的素材 */
  onPasteCopyFile = () => {
    const { material: { pageData }, dispatch } = this.props;
    const { pageNum, pageSize } = pageData;
    let { copyKeys: { fileIds }, folderId, typeData: { currentType } } = this.state;
    let payload = this.getPayload({}, pageNum, pageSize);
    let condition = Object.assign({}, payload);
    // 复制素材
    if (fileIds && fileIds.length > 0) {
      condition.id = fileIds.join(',');
      condition.folderId = folderId;
      condition.is_share = "";
      condition.type = currentType;
      dispatch({
        type: 'material/copyMaterial',
        condition: condition,
        payload: payload,
        success: () => {
          notice.success(window.language['material.parseSuccess']);
          this.onCopyDataClear();
        }
      });
    }
  }

  /** 粘贴剪切的素材
   * folderIds: 拷贝的文件夹id
   * copyFolderId: 拷贝的文件夹的pid
   * folderId: 拷贝至目标的当前id
   */
  onPasteCutFile = () => {
    const { material: { pageData }, dispatch } = this.props;
    const { pageNum, pageSize } = pageData;
    let { copyKeys: { folderIds, fileIds, copyFolderId }, folderId, typeData: { currentType } } = this.state;
    let payload = this.getPayload({}, pageNum, pageSize);
    let folderCondition = {};//文件夹入参
    let fileCondition = {};//文件入参
    if (copyFolderId === folderId) {
      notice.warning(window.language['material.sourceTargetSame']);
      return;
    }
    // 剪切文件夹
    if (folderIds && folderIds.length > 0) {
      
      //要剪切的文件夹ID
      folderCondition.id = folderIds.join(',');

      //即将粘贴到的文件夹
      folderCondition.pid = folderId;

      folderCondition.type = currentType;

      dispatch({
        type: 'folder/qryFolderParentList',
        condition: { id: folderId },
        success: (folderArr) => {
          let flag = false;
          for (let item of folderArr) {
            let index = folderIds.indexOf(item.id);
            if (index !== -1) {
              flag = true;
              break;
            }
          }
          if (flag) {
            notice.warning(window.language['material.nonsupportCutFolderTip']);
            return;
          }
          dispatch({
            type: 'material/updateFolder',
            condition: folderCondition,
            payload: payload,
            success: () => {
              notice.success(window.language['material.parseSuccess']);
              this.onCopyDataClear();
              this.getFoldersTree();
            }
          });
        }
      });
    }
    // 剪切素材
    if (fileIds && fileIds.length > 0) {
      fileCondition.id = fileIds.join(',');
      fileCondition.folderId = folderId;
      fileCondition.is_share = "";
      if (currentType === '18') {
        fileCondition.indexs = '-1';
        fileCondition.model = '-1';
      }
      let url = getUpdateUrl(currentType);
      if (!url) {
        return;
      }
      dispatch({
        type: url,
        condition: fileCondition,
        payload: payload,
        success: () => {
          notice.success(window.language['material.parseSuccess']);
          this.onCopyDataClear();
        }
      });
    }
  }

  /** 
   * 删除功能
   * 如果item有值，则删除传入的内容
   */
  onDeleteFile = (e, item) => {
    let checkRows = this.state.checkRows;
    if (item && item.id) {
      checkRows = [item];
    }
    let picIds = '';
    let folderIds = '';
    if (checkRows.length <= 0) {
      return;
    }

    var deleteTipContent = `${window.language['material.delTipMsg']}${checkRows.length}${window.language['material.delItems']}`;

    for (let val of checkRows) {
      if (val.scope) {
        deleteTipContent = window.language['material.delFolderTip'] + deleteTipContent;
        break;
      }
    }
    
    confirm({
      title: window.language['material.notice'],
      okText: window.language['common.ok'],
      cancelText: window.language['common.cancel'],
      className: 'custom-modal',
      content: deleteTipContent,
      style: { width: 416, height: 163 },
      onOk: () => {
        for (let val of checkRows) {
          if (!val.scope) {
            picIds += val.id + ',';
          } else {
            let id = val.id;
            id = id.split("_")[0];
            folderIds += id + ',';
          }
        }
        if (picIds) {
          this.delMaterial(picIds);
        }
        if (folderIds) {
          this.delFolder(folderIds);
        }
      }
    });
  }

  /** 删除素材 */
  delMaterial = (picIds) => {
    const { material: { pageData }, dispatch } = this.props;
    const { pageNum, pageSize } = pageData;
    let payload = this.getPayload({}, pageNum, pageSize);
    let condition = Object.assign({}, payload);
    condition.ids = picIds.substring(0, picIds.length - 1);
    dispatch({
      type: 'material/delMaterial',
      condition: condition,
      payload: payload,
      success: (root) => {
        // 如果操作成功，在已选择的行中，排除删除的行
        notice.success(window.language['conmmon.del.success']);
        this.onMaterialClear();
        let loginUser = $$.getStore("user");
        loginUser.usedDiskSpace = root;
        $$.setStore("user",loginUser);
      }
    });
  }

  /** 删除文件夹 */
  delFolder = (folderIds) => {
    const { material: { pageData }, dispatch } = this.props;
    const { pageNum, pageSize } = pageData;
    let payload = this.getPayload({}, pageNum, pageSize);
    let condition = Object.assign({}, payload);
    condition.ids = folderIds.substring(0, folderIds.length - 1);
    this.delFolderRequest(condition, payload);
  }

  /** 删除文件夹请求 */
  delFolderRequest = (condition, payload) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'material/delFolder',
      condition: condition,
      payload: payload,
      success: () => {
        // 如果操作成功，在已选择的行中，排除删除的行
        notice.success(window.language['conmmon.del.success']);
        this.getFoldersTree();
        this.onMaterialClear();
      }
    });
  }

  /** 
   * 分享素材/取消分享功能
   * type: 0:分享 1:取消分享
   */
  onShareFile = (e, type, item) => {
    const { material: { parentOrgIds } } = this.props;
    let checkRows = this.state.checkRows;
    let arr = [];
    if (parentOrgIds && parentOrgIds.length > 0) {
      arr = parentOrgIds.split(",");
    }
    if (item && item.id) {
      checkRows = [item];
    }
    if (checkRows.length <= 0) {
      return;
    }
    let fileIds = "";
    for (let row of checkRows) {
      if (row.scope) {
        notice.warning(window.language['material.nonsupportOperFolder']);
        return;
      }
      fileIds += row.id + ",";
      let index = arr.indexOf(row.org.id);
      if (index !== -1) {
        notice.warning(window.language['material.nonsupportParentShareOper']);
        return;
      }
    }
    fileIds = fileIds.substring(0, fileIds.length -1);
    // 检查是否支持分享
    let tipMsg = window.language['material.noShareTipMsg'];
    let shareStatus = '0';
    let successTipMsg = window.language['material.cancelShareSuccess'];
    if (type === '0') {
      tipMsg = window.language['material.shareTipMsg'];
      shareStatus = '1';
      successTipMsg = window.language['material.shareSuccess'];
    }
    confirm({
      title: window.language['material.notice'],
      okText: window.language['common.ok'],
      cancelText: window.language['common.cancel'],
      className: 'custom-modal',
      content: `${tipMsg}${checkRows.length}${window.language['material.delItems']}`,
      style: { width: 416, height: 163 },
      onOk: () => {
        const { material: { pageData }, dispatch } = this.props;
        const { pageNum, pageSize } = pageData;
        let { typeData: { currentType } } = this.state;
        let payload = this.getPayload({}, pageNum, pageSize);
        let condition = {};
        condition.is_share = shareStatus;
        condition.id = fileIds;
        if (currentType === '18') {
          condition.indexs = '-1';
          condition.model = '-1';
        }
        let url = getUpdateUrl(currentType);
        dispatch({
          type: url,
          condition: condition,
          payload: payload,
          success: () => {
            notice.success(successTipMsg);
            this.qryMaterialList();
          }
        });
      }
    });
  }

  /** 预览: 隐藏预览窗口 */
  hidePreviewHandler = (e) => {
    this.setState({
      previewVisible: false,
      previewRows: [],
    });
  };

  /** 预览: 显示预览窗口 */
  onShowPreviewHandler = (e, checkObj) => {
    const { material: { pageData } } = this.props;
    let picRows = [];
    let list = pageData.list;
    if (list && list.length > 0) {
      for (let row of list) {
        if (!row.scope) {//scope==="0"为文件夹，scope===undefined为对应素材
          picRows.push(row);
        }
      }
    }
    this.setState({
      previewVisible: true,
      checkObj,
      previewRows: picRows,
    });
  };

  /** 重命名: 显示窗口 */
  onShowRename = (e, checkObj) => {
    this.setState({
      renameVisible: true,
      checkObj,
    });
  }

  /** 重命名: 隐藏窗口 */
  hideRenameHandler = (e) => {
    this.setState({
      renameVisible: false,
    });
  }

  /** 重命名: 存入form */
  saveRenameCompFormRef = (renameFormRef) => {
    this.renameFormRef = renameFormRef;
  }

  /** 重命名: 保存重命名 */
  renameHandler = (e) => {
    const { material: { pageData }, dispatch } = this.props;
    const { filters, pageNum, pageSize } = pageData;
    const form = this.renameFormRef.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        let { checkObj, folderId, typeData: { currentType } } = this.state;
        if (!checkObj || checkObj.scope) {
          return;
        }
        let rename = values.name.trim();
        let id = checkObj.id;
        id = id.split("_")[0];
        let payload = this.getPayload(filters, pageNum, pageSize);
        let condition = {};
        condition.folderIds = folderId
        condition.name = rename;
        condition.id = id;
        condition.type = currentType;
        let officeFlag = currentType === '15' || currentType === '16' || currentType === '17' || currentType === '35';
        if (officeFlag) {
          // 更改office信息
          condition.interval_time = moment(values.interval_time).format('HH:mm:ss');
          condition.transit_mode = values.transit_mode;
        } else {
          if (checkObj.name === rename) {
            notice.success(window.language['conmmon.update.success']);
            this.hideRenameHandler();
            return;
          }
        }
        let url = getUpdateUrl(currentType);
        dispatch({
          type: url,
          condition: condition,
          payload: payload,
          success: () => {
            checkObj.name = rename;
            if (officeFlag) {
              let count = 0;
              let { interval_time } = condition;
              if (checkObj.previewList) {
                count = checkObj.previewList.length;
              }
              checkObj.interval_time = interval_time;
              checkObj.playtime = multiTime(interval_time, count);
            }
            this.hideRenameHandler();
            notice.success(window.language['conmmon.update.success']);
          }
        });
      }
    });
  }

  /** 显示窗口 type 0:新建 1:编辑 2:查看 */
  onShowRss = (e, type, checkObj) => {
    if (type === '0') {
      this.setState({
        dynamicTextTitle: {
          type: '0',
          title: window.language['rss.addRss'],
        },
        rssVisible: true,
      });
    } else if (type === '1'){
      this.setState({
        dynamicTextTitle: {
          type: '1',
          title: window.language['rss.updateRss'],
        },
        rssVisible: true,
        checkObj,
      });
    } else {
      this.setState({
        dynamicTextTitle: {
          type: '2',
          title: window.language['rss.findRss'],
        },
        rssVisible: true,
        checkObj,
      });
    }
  }

  /** 新建、编辑Rss: 隐藏窗口 */
  hideRssHandler = (e) => {
    this.setState({
      rssVisible: false,
      checkObj: {},
    });
  }

  /** 新建、编辑Rss: 存入form */
  rssCompFormRef = (rssFormRef) => {
    this.rssFormRef = rssFormRef;
  }

  /** 新建、编辑Rss: 保存Rss */
  rssHandler = (e, isCheck) => {
    const { material: { pageData }, dispatch } = this.props;
    const { filters, pageNum, pageSize } = pageData;
    const form = this.rssFormRef.props.form;
    let { type } = this.state.dynamicTextTitle;
    if (type === '2') {
      this.hideRssHandler();
      return;
    }
    form.validateFields((err, values) => {
      if (!err) {
        let payload = this.getPayload(filters, pageNum, pageSize);
        let condition = Object.assign({}, payload);
        condition.id = values.id;
        condition.name = values.name.trim();
        condition.url = values.url.trim();
        condition.model = values.model;
        condition.nlines = values.nlines;
        condition.remark = values.remark.trim();
        condition.is_share = "";
        if (isCheck) {
          dispatch({
            type: 'material/checkRssURL',
            condition: condition,
            payload: payload,
            success: (content) => {
              let checkObj = this.state.checkObj;
              checkObj.content = content;
              this.setState({
                checkObj
              });
            }
          });
        } else {
          let url = "";
          let noticeMsg = "";
          if (type === '0') {
            url = "material/addRss";
            noticeMsg = window.language['rss.addRss.success'];
          } else {
            url = 'material/updateRss';
            noticeMsg = window.language['rss.updateRss.success'];
          }
          dispatch({
            type: url,
            condition: condition,
            payload: payload,
            success: () => {
              notice.success(noticeMsg);
              this.hideRssHandler();
              this.onMaterialClear();
            }
          });
        }
      }
    });
  }

  /** 下载素材 */
  onDownloadMaterial = (e, checkObj) => {
    if (!checkObj || !checkObj.id) {
      return;
    }
    const { dispatch } = this.props;
    let { typeData: { currentType } } = this.state;
    let id = checkObj.id;
    let url = getDownloadUrl(currentType);
    dispatch({
      type: url,
      payload: {
        id: id,
      }
    });
  }

  render() {
    const { material: { pageData, parentOrgIds }, loading, type, selectType = "0", modal } = this.props;
    
    let authCodes = $$.getStore('authCodes');//按钮权限代码列表
    if (!authCodes) return null;

    const { tabsType, collapsed, graphListType, folderId, checkRows, checkKeys, showKeys, typeData: { currentType, isShare, otherShare }, btnDisabled,
      uploadVisible,                         // 上传窗口显隐
      addFolderVisible,                      // 新建文件夹窗口显隐
      addLiveVisible,                        // 新建流媒体、web窗口显隐
      previewVisible,                        // 预览窗口显隐
      renameVisible,                         // 重命名窗口显隐
      rssVisible,                            // RSS窗口显隐
      modelVisible,                          // 素材模态窗显隐状态记录 
      materialSize,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    if (
      uploadVisible || 
      addFolderVisible || 
      addLiveVisible || 
      previewVisible || 
      renameVisible || 
      rssVisible || 
      modelVisible ||
      checkRows.length > 0
    ) {
      this.clearInterval();
    } else {
      this.setInterval(pageData);
    }
    let columns = {};
    let previewTitle = '';       // 预览名称
    let showAddLi = null;        // 上传、新建显示
    let allCheckLi = null;       // 全选
    /*  
     * 按钮权限: 
     *    上传/新建、修改、删除素材、
     *    删除文件夹、新建文件夹、编辑文件夹、
     *    分享、复制、剪切、下载
     */
    let buttonAuth = ["", "", "", "", "", "", "", "", ""];
    if (currentType === '0') {   // 视频
      previewTitle = window.language['video.preview'];
      buttonAuth = ["MATERIAL.VIDEO.UPLOAD", "MATERIAL.VIDEO.EDIT", "MATERIAL.VIDEO.DELETE",
      "MATERIAL.VIDEO.FOLDER.DELETE", "MATERIAL.VIDEO.FOLDER.ADD", "MATERIAL.VIDEO.FOLDER.EDIT",
      "MATERIAL.VIDEO.SHARE", "MATERIAL.VIDEO.COPY", "MATERIAL.VIDEO.CUT", "MATERIAL.VIDEO.DOWNLOAD"];
      columns = columnsVideo(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '1') {   // 图片
      previewTitle = window.language['pic.preview'];
      buttonAuth = ["MATERIAL.PICTURE.UPLOAD", "MATERIAL.PICTURE.EDIT", "MATERIAL.PICTURE.DELETE",
      "MATERIAL.PICTURE.FOLDER.DELETE", "MATERIAL.PICTURE.FOLDER.ADD", "MATERIAL.PICTURE.FOLDER.EDIT",
      "MATERIAL.PICTURE.SHARE", "MATERIAL.PICTURE.COPY", "MATERIAL.PICTURE.CUT", "MATERIAL.PICTURE.DOWNLOAD"];
      columns = columnsPicture(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '2') {   // 音乐
      previewTitle = window.language['music.musicPlay'];
      buttonAuth = ["MATERIAL.MUSIC.UPLOAD", "MATERIAL.MUSIC.EDIT", "MATERIAL.MUSIC.DELETE",
      "MATERIAL.MUSIC.FOLDER.DELETE", "MATERIAL.MUSIC.FOLDER.ADD", "MATERIAL.MUSIC.FOLDER.EDIT",
      "MATERIAL.MUSIC.SHARE", "MATERIAL.MUSIC.COPY", "MATERIAL.MUSIC.CUT", "MATERIAL.MUSIC.DOWNLOAD"];
      columns = columnsMusic(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '15') {   // Word
      previewTitle = window.language['word.preview'];
      buttonAuth = ["MATERIAL.DOC.UPLOAD", "MATERIAL.DOC.EDIT", "MATERIAL.DOC.DELETE",
      "MATERIAL.DOC.FOLDER.DELETE", "MATERIAL.DOC.FOLDER.ADD", "MATERIAL.DOC.FOLDER.EDIT",
      "MATERIAL.DOC.SHARE", "MATERIAL.DOC.COPY", "MATERIAL.DOC.CUT", "MATERIAL.DOC.DOWNLOAD"];
      columns = columnsOffice(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '16') {   // Excel
      previewTitle = window.language['excel.preview'];
      buttonAuth = ["MATERIAL.XLS.UPLOAD", "MATERIAL.XLS.EDIT", "MATERIAL.XLS.DELETE",
      "MATERIAL.XLS.FOLDER.DELETE", "MATERIAL.XLS.FOLDER.ADD", "MATERIAL.XLS.FOLDER.EDIT",
      "MATERIAL.XLS.SHARE", "MATERIAL.XLS.COPY", "MATERIAL.XLS.CUT", "MATERIAL.XLS.DOWNLOAD"];
      columns = columnsOffice(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '17') {   // PPT
      previewTitle = window.language['ppt.preview'];
      buttonAuth = ["MATERIAL.PPT.UPLOAD", "MATERIAL.PPT.EDIT", "MATERIAL.PPT.DELETE",
      "MATERIAL.PPT.FOLDER.DELETE", "MATERIAL.PPT.FOLDER.ADD", "MATERIAL.PPT.FOLDER.EDIT",
      "MATERIAL.PPT.SHARE", "MATERIAL.PPT.COPY", "MATERIAL.PPT.CUT", "MATERIAL.PPT.DOWNLOAD"];
      columns = columnsOffice(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '35') {   // PDF
      previewTitle = window.language['pdf.preview'];
      buttonAuth = ["MATERIAL.PDF.UPLOAD", "MATERIAL.PDF.EDIT", "MATERIAL.PDF.DELETE",
      "MATERIAL.PDF.FOLDER.DELETE", "MATERIAL.PDF.FOLDER.ADD", "MATERIAL.PDF.FOLDER.EDIT",
      "MATERIAL.PDF.SHARE", "MATERIAL.PDF.COPY", "MATERIAL.PDF.CUT", "MATERIAL.PDF.DOWNLOAD"];
      columns = columnsOffice(this, showKeys, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '7') {   // 网页
      previewTitle = window.language['live.pagePreview'];
      buttonAuth = ["MATERIAL.WEB.ADD", "MATERIAL.WEB.EDIT", "MATERIAL.WEB.DELETE",
      "MATERIAL.WEB.FOLDER.DELETE", "MATERIAL.WEB.FOLDER.ADD", "MATERIAL.WEB.FOLDER.EDIT",
      "MATERIAL.WEB.SHARE", "MATERIAL.WEB.COPY", "MATERIAL.WEB.CUT", ""];
      columns = columnsLive(this, parentOrgIds, isShare, buttonAuth);
    }
    else if (currentType === '18') {   // RSS
      buttonAuth = ["MATERIAL.RSS.ADD", "MATERIAL.RSS.EDIT", "MATERIAL.RSS.DELETE",
      "MATERIAL.RSS.FOLDER.DELETE", "MATERIAL.RSS.FOLDER.ADD", "MATERIAL.RSS.FOLDER.EDIT",
      "MATERIAL.RSS.SHARE", "MATERIAL.RSS.COPY", "MATERIAL.RSS.CUT", ""];
      columns = columnsDynamicText(this, parentOrgIds, isShare, buttonAuth);
    }

    if (authCodes[buttonAuth[0]]) {
      if (currentType === '7') {
        showAddLi = (
          <li className="tool-icon-default-button" onClick={(e) => { this.onShowAddLive(e, '0') }}>
            <Icon className="material-web-add" /><span>{window.language['common.add']}</span>
          </li>
        );
      } else if (currentType === '18') {
        showAddLi = (
          <li className="tool-icon-default-button">
            <Icon className="material-rss-add"  onClick={(e) => { this.onShowRss(e, '0') }}/><span>{window.language['common.add']}</span>
          </li>
        );
      } else {
        showAddLi = (
          <li className="tool-icon-default-button" onClick={(e) => { this.onShowUpload(e) }}>
            <Icon className="upload" /><span>{window.language['common.upload']}</span>
          </li>
        );
      }
    }

    let uploadProps  = {
      visible: uploadVisible,
      ref: "uploadModalObj",
      close: this.hideUploadHandler,
      folderId: folderId,
      callBack: this.qryMaterialList,
      currentType: currentType,
      //type: [currentType],
      type: this.props.type,
      tips: window.language['pic.bigSensePicPrompt']
    }

    if (graphListType === '0' && selectType === '0') {
      if (pageData && pageData.list) {
        allCheckLi = (
          <li className={`${pageData.list.length === 0 ? 'tool-icon-gray-button' : 'tool-icon-default-button'}`} onClick={(e) => { this.onCheckAll() }}>
            <Icon className="material-checkall" />
            <span>{checkRows.length === pageData.list.length && pageData.list.length !== 0 ? window.language['common.cancel'] : window.language['material.checkAll']}</span>
          </li>
        );
      }
    }

    /* 加载面包屑 */
    const itemRender = (route, params, routes, paths) => {
      let routeLength = routes.length;
      let last = routes.indexOf(route) === routes.length - 1;
      if (last) {
        if (routeLength === 1) {
          return <span className="material-breadcrumb-noclick">{window.language['material.all']}{materialTitleObjMap.get(currentType).title}</span>
        } else {
          return <span className="material-breadcrumb-noclick">{route.breadcrumbName.substring(0, route.breadcrumbName.lastIndexOf('_'))}</span>
        }
      } else {
        if (route.id === this.userFolderId) {
          let nameArr = route.breadcrumbName.split("/");
          if (nameArr && nameArr.length >= '2') {
            // 0: 当前点击目录 1: 上级目录 2: 顶级目录
            return (
              <span>
                <span className="material-breadcrumb-click" onClick={(e) => { this.onSwitchBreadCrumb(e, route, '1') }}>
                  {nameArr[0].trim().substring(0, nameArr[0].trim().lastIndexOf('_'))}
                </span>
                <span> / </span>
                <span className="material-breadcrumb-click" onClick={(e) => { this.onSwitchBreadCrumb(e, route, '2') }}>
                  {nameArr[1].trim().substring(0, nameArr[1].trim().lastIndexOf('_'))}
                </span>
              </span>
            )
          }
        }
        return (
          <span className="material-breadcrumb-click" onClick={(e) => { this.onSwitchBreadCrumb(e, route, '0') }}>
            {route.breadcrumbName.substring(0, route.breadcrumbName.lastIndexOf('_'))}
          </span>
        )
      }
    }

    /** 图形模式参数 */
    const graphProps = {
      loading: loading,
      material: { pageData },
      typeData: { currentType, isShare },
      selectType: selectType,
      checkKeys: checkKeys,
      checkRows: checkRows,
      parentOrgIds: parentOrgIds,
      buttonAuth,
      authCodes,
      onMaterialChecked: this.onMaterialChecked,
      onDoubleClickData: this.onDoubleClickData,
      onShowAddFolder: this.onShowAddFolder,
      onDeleteFile: this.onDeleteFile,
      onShowAddLive: this.onShowAddLive,
      onShareFile: this.onShareFile,
      onShowPreviewHandler: this.onShowPreviewHandler,
      onShowRename: this.onShowRename,
      onShowRss: this.onShowRss,
      onDownloadMaterial: this.onDownloadMaterial,
      onCheckedMaterialData: this.onCheckedMaterialData,
      materialSize,
    }

    let yWidth = 395;

    // if (getWinSize().winWidth >= 1920) {
    //   yWidth = 395;
    // } else if (getWinSize().winWidth >= 1600) {
    //   yWidth = 348;
    // } else if (getWinSize().winWidth >= 1440) {
    //   yWidth = 326;
    // } else if (getWinSize().winWidth >= 1366) {
    //   yWidth = 310;
    // } else if (getWinSize().winWidth >= 1280) {
    //   yWidth = 300;
    // }

    let yPlaylistWidth = 432;

    // if (getWinSize().winWidth >= 1920) {
    //   yPlaylistWidth = 432;
    // } else if (getWinSize().winWidth >= 1600) {
    //   yPlaylistWidth = 397;
    // } else if (getWinSize().winWidth >= 1440) {
    //   yPlaylistWidth = 383;
    // } else if (getWinSize().winWidth >= 1366) {
    //   yPlaylistWidth = 376;
    // } else if (getWinSize().winWidth >= 1280) {
    //   yPlaylistWidth = 369;
    // }
    
    /** 列表模式参数 */
    const listProps = {
      loading: loading,
      columns,
      rowKey: 'id',
      dataItems: pageData,
      selectType: selectType === '0' ? 'checkbox' : 'radio',
      showNum: false,
      isScroll: false,
      scroll: { y: modal !== 'playlist' ? `calc(100vh - ${yWidth}px)` : `calc(100vh - ${yPlaylistWidth}px)` },
      selectedRowKeys: checkRows.map(item => item.id),
      rowSelection: {
        onSelectAll: (selected, selectedRows) => {
          // 全选
          if (selected) {
            let keys = [];
            for (let obj of selectedRows) {
              keys.push(obj.id);
            }
            this.onMaterialChecked(selectedRows, keys);
          } else {
            this.onMaterialClear();
          }
        },
        onSelect: (record, selected, rows) => {
          // 复选框勾选
          let keys = [];
          for (let obj of rows) {
            keys.push(obj.id);
          }
          this.onMaterialChecked(rows, keys);
        },
      },
      onChange: ({ pageNum = pageData.pageNum, pageSize = pageData.pageSize }) => {
        pageData.jumpPage(pageNum, pageSize);

        this.props.form.validateFields((err, values) => {
          if (!err) {
            this.initSearch(values, pageNum, pageSize);
          }
        });
        
        this.onMaterialClear();
      },
      onRow: (record) => {
        return {
          draggable: true,
          onMouseDown: (e) => {
            if (selectType === '0') {
              // 单击行-多选
              let target = e.target || e.srcElement;
              if (target.type !== 'checkbox') {
                let rows = [...checkRows];
                let keys = [...checkKeys];
                let rowsFindIndex = rows.findIndex(val => val.id === record.id);
                if (rowsFindIndex !== -1) {
                  rows.splice(rowsFindIndex, 1);
                  keys.splice(rowsFindIndex, 1);
                } else {
                  rows = [...rows, record];
                  keys = [...keys, record.id];
                }
                this.onMaterialChecked(rows, keys);
              }
            } else {
              this.onMaterialChecked([record], [record.id]);
            }
          },
        };
      }
    }

    /** 左侧树组件参数 */
    const treeProps = {
      type,
      onChangeCurrentType: this.onChangeCurrentType,
      typeData: { currentType, isShare, otherShare },
      tabsType,
      folderId: folderId,
      userFolderId: this.userFolderId,
      folderNodes: this.state.folderNodes,
      floderNodesChange: this.state.floderNodesChange,
    }

    // 新建、编辑文件夹
    const folderProps = {
      folderTitle: this.state.folderTitle,
      visible: addFolderVisible,
      folderData: this.state.checkObj,
      hideAddEditFolderHandler: this.hideAddEditFolderHandler,
      addEditFolderHandler: this.addEditFolderHandler,
    }

    // 流媒体、web
    const liveProps = {
      liveTitle: this.state.liveTitle,
      visible: addLiveVisible,
      liveData: this.state.checkObj,
      hideAddLiveHandler: this.hideAddLiveHandler,
      addLiveHandler: this.addLiveHandler,
    }

    // 预览
    const previewProps = {
      title: previewTitle,
      visible: previewVisible,
      checkObj: this.state.checkObj,
      previewRows: this.state.previewRows,
      type: currentType,
      hidePreviewHandler: this.hidePreviewHandler,
    }

    // 重命名
    const renameProps = {
      type: currentType,
      visible: renameVisible,
      checkObj: this.state.checkObj,
      hideRenameHandler: this.hideRenameHandler,
      renameHandler: this.renameHandler,
    }

    // 新建、编辑RSS
    const rssProps = {
      dynamicTextTitle: this.state.dynamicTextTitle,
      visible: rssVisible,
      dynamicTextData: this.state.checkObj,
      hideRssHandler: this.hideRssHandler,
      rssHandler: this.rssHandler,
    }

    let graphStyle = {}
    if (graphListType === '0') {
      graphStyle.backgroundColor = '@cdms-theme-bgcolor';
    }
    let materialModalSyle = {height:getWinSize().winHeight - 119};
    let materialTreeStyle = {height: getWinSize().winHeight - 207};
    let siderW = getMenuWidth('materialTree');
    if(this.props.visible){//播放列表弹层选择素材
      materialModalSyle = {height:getWinSize().winHeight - 132};
      materialTreeStyle = {height: getWinSize().winHeight - 219};
    }else{
      materialModalSyle = {height: 'auto'};
      materialTreeStyle = {height: getWinSize().winHeight - 207};
    }
    
    return (
      <Layout className="full-layout cdms-layout material-page" style={materialModalSyle}>
        <Sider 
          width={siderW} 
          className="material-side"
          collapsed={collapsed} 
          collapsible={true} 
          trigger={null} 
          collapsedWidth={0}
        >
          <a className="material-side-handle" onClick={this.onSiderToggle} >
            <Icon className={collapsed ? 'right-arrow-o' : 'left-arrow-o'} />
          </a>
          <Header className="material-tabs-head">
            <div className={`material-tabs ${tabsType === '0' ? 'material-check' : 'material-no-check-left'}`} onClick={(e) => {this.onChangeTabs(e, '0')}}>
              {window.language['material.myMaterial']}
            </div>
            <div className={`material-tabs ${tabsType === '1' ? 'material-check' : 'material-no-check-right'}`} onClick={(e) => {this.onChangeTabs(e, '1')}}>
              {window.language['material.shareMaterial']}
            </div>
          </Header>
          <Content className="material-side-tree" style={materialTreeStyle}>
            <MaterialTreeComponent {...treeProps} />
          </Content>
        </Sider>
        <Layout>
          <Header className="material-body-head" style={graphListType === '0' ? {} : { borderBottom: '0px' }}>
            <div className="material-body-head-top">
              <div className="material-head-top-left">
                <Breadcrumb className="material-breadcrumb" separator=">" itemRender={itemRender} routes={this.state.routes} />
              </div>
              <div className="material-head-top-right">
                {/* <Form onSubmit={this.onSearch} className="login-form">
                  <Form.Item> */}
                    { getFieldDecorator('name')(
                      <Input 
                        className="material-soso-input" 
                        placeholder={window.language['material.pleaseSearchName']} 
                        onKeyDown={(e) => {
                          if(e.keyCode == "13") {
                            this.onSearch();
                          }
                        }}
                        prefix={
                          <Icon className="search-o" onClick={this.onSearch} />
                        } 
                      />
                    )}
                  {/* </Form.Item>
                </Form> */}
              </div>
            </div>
            <div className="material-body-head-bottom">
              <div className="material-head-bottom-left">
                { isShare === '0' ? (
                  <ul className="tool-icon-button">
                    {authCodes[buttonAuth[4]] ? (
                    <li className="tool-icon-default-button" onClick={(e) => { this.onShowAddFolder(e, '0') }}>
                      <Icon className="material-add" /><span>{window.language['material.folder.new']}</span>
                    </li>
                    ) : null}
                    {showAddLi}
                    {allCheckLi}
                    {authCodes[buttonAuth[7]] ? (
                    <li className={ btnDisabled[1] ? 'tool-icon-gray-button' : 'tool-icon-default-button' } onClick={(e) => { this.onCopyCutFile('0') }}>
                      <Icon className="material-copy" /><span>{window.language['material.copy']}</span>
                    </li>
                    ) : null}
                    {authCodes[buttonAuth[8]] ? (
                    <li className={ btnDisabled[2] ? 'tool-icon-gray-button' : 'tool-icon-default-button' } onClick={(e) => { this.onCopyCutFile('1') }}>
                      <Icon className="cut" /><span>{window.language['material.cut']}</span>
                    </li>
                    ) : null}
                    {authCodes[buttonAuth[7]] || authCodes[buttonAuth[8]] ? (
                    <li className={ btnDisabled[3] ? 'tool-icon-gray-button' : 'tool-icon-default-button' } onClick={(e) => { this.onPasteFile(e) }}>
                      <Icon className="material-paste"/><span>{window.language['material.parse']}</span>
                    </li>
                    ) : null}
                    {authCodes[buttonAuth[2]] && authCodes[buttonAuth[3]] ? (
                    <li className={ btnDisabled[4] ? 'tool-icon-gray-button' : 'tool-icon-default-button' } onClick={(e) => { this.onDeleteFile(e) }}>
                      <Icon className="delete" /><span>{window.language['common.del']}</span>
                    </li>
                    ) : null}
                    {authCodes[buttonAuth[6]] ? (
                    <li className={ btnDisabled[5] ? 'tool-icon-gray-button' : 'tool-icon-default-button' } onClick={(e) => { this.onShareFile(e, '0') }}>
                      <Icon className="share" /><span>{window.language['material.share']}</span>
                    </li>
                    ) : null}
                  </ul>
                ) : (
                  <ul className="tool-icon-button">
                    {authCodes[buttonAuth[6]] ? (
                    <li className={ btnDisabled[5] ? 'tool-icon-gray-button' : 'tool-icon-default-button' } onClick={(e) => { this.onShareFile(e, '1') }}>
                      <Icon className="share-no" /><span>{window.language['material.cancelShare']}</span>
                    </li>
                    ) : null}
                    {allCheckLi}
                  </ul>
                )}
              </div>
              <div className="material-head-bottom-right">
                <SwitchTab onSwitch={this.onSwitch} />
              </div>
            </div>
          </Header>
          <Content className="material-content-center" style={graphStyle}>
            { graphListType === '0' ? <MaterialGraphComponent {...graphProps} /> : <MaterialListComponent {...listProps} /> }
          </Content>
          <Footer style={graphStyle}>
            <Pagination {...listProps} />
          </Footer>
          {uploadVisible === true ? (
            <UploadModal {...uploadProps} />
          ) : null}
          {addFolderVisible === true ? (
            <AddEditFolderComponent wrappedComponentRef={this.saveAddEditFolderCompFormRef} {...folderProps} />
          ) : null}
          {addLiveVisible === true ? (
            <AddWebComponent wrappedComponentRef={this.liveCompFormRef} {...liveProps} />
          ) : null}
          {previewVisible === true ? (
            <PreviewComponent {...previewProps} />
          ) : null}
          {renameVisible === true ? (
            <RenameComponent wrappedComponentRef={this.saveRenameCompFormRef} {...renameProps} />
          ) : null}
          {rssVisible === true ? (
            <AddEditRss wrappedComponentRef={this.rssCompFormRef} {...rssProps}  />
          ) : null}
        </Layout>
      </Layout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/materialComponent.js